module.exports = new __parcel__URL__("x-icon.3a3af793.svg").toString();